import { Component, OnInit, Inject } from '@angular/core';
import { HsgModalDefault, HsgModalRef, HSG_MODAL_DATA, HsgModalDefaultData } from '@hhsg/hsg-asc';
import { Router } from '@angular/router';

@Component({
  selector: 'smt-no-staffing-grid-modal',
  templateUrl: './no-staffing-grid-modal.component.html',
  styleUrls: ['./no-staffing-grid-modal.component.scss']
})
export class NoStaffingGridModalComponent extends HsgModalDefault {
  constructor(
		public modalRef: HsgModalRef<HsgModalDefault>,
    @Inject(HSG_MODAL_DATA) public data: any,
    private _route: Router
	) {
    super(modalRef,data);
  }
  ngOnInit(): void {
    this.modalRef.afterClosed().subscribe((data) => {
      if (data === undefined) {
        this._route.navigateByUrl(this.data['acceptLink']);
      }
    });
  }
}
